import { WorkHistoryItemData } from './interface';
import { Text } from '@medely/ui-kit';
import React from 'react';

export const WorkGapInfo = ({ workHistoryItem }: { workHistoryItem: WorkHistoryItemData }) => {
  return (
    <>
      <Text size="m" color="text.secondary" testId="work-history-item-work-gap-title">
        Work Gap
      </Text>
      <Text size="m" color="text.secondary" testId="work-history-item-work-gap-explanation">
        {workHistoryItem.explanation}
      </Text>
    </>
  );
};
